import { useRecoilState } from "recoil"
import { snackbarState } from "src/store/global/snackbarState";
import SnackbarCustom from "./SnackbarCustom";

const GlobalShowSnackbar = () => {

    const [snackbar] = useRecoilState(snackbarState);

    if(snackbar) {
        return (<SnackbarCustom {...snackbar} />)
    }

    return null;
}

export default GlobalShowSnackbar;
